import { Routes } from '@angular/router';
import { LoginComponent } from './login';

export const ROUTES: Routes = [
  { path: 'login', component: LoginComponent },
  { path: '',      redirectTo: '/maintenance/list', pathMatch: 'full' },
  { path: 'user', loadChildren: './user#UserModule'},
  { path: 'maintenance', loadChildren: './maintenance#MaintenanceModule'},
  { path: 'intervention', loadChildren: './intervention#InterventionModule'},
  { path: 'station', loadChildren: './station#StationModule'},
  { path: 'issue', loadChildren: './issue#IssueModule'},
  { path: '**',    redirectTo: '' },
];



// WEBPACK FOOTER //
// ./src/app/app.routes.ts